<template>
  <div>
    <DeleteModal
      :is-delete-modal-active.sync="isDeleteModalActive"
      :items="deleteItem"
      @confirm-delete="confirmDelete($event)" />
    <TicketPlantAdd
      ref="ticketPlantAdd"
      :is-sidebar-active.sync="isSidebarActive"
      @add-ticket-plant="addTicketPlant($event)"
    />
    <TicketPlantDetail
      :is-sidebar-active.sync="isSidebarDetailActive"
      :initial-ticket-plant="initialTicketPlant"
      :selected-item.sync="selectedItem"
      @update-ticket-plant="updateTicketPlant($event)"
      @delete-item="openDeleteModal($event)" />
    <TicketPlantFilter
      :search.sync="filter.searchCodeAndName"
      :status-filter.sync="filter.status"
      @fetch-filter="fetchFilter()" />
    <b-card class="mt-2">
      <TableTop
        v-model="pagination.limit"
        label="Add Plant"
        @active-sidebar="activeSidebar()"
        @change="fetchFilter()" />
      <b-table
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
        @sort-changed="sortFilter($event)"
        @row-clicked="rowClick($event)">
        <template #cell(status)="data">
          <b-badge :variant="$statusValue(data.value)">
            {{ data.value | formatStatusData }}
          </b-badge>
        </template>
        <template #cell(code)="data">
          <span class="font-weight-semibold text-primary">#{{ data.value }}</span>
        </template>
        <template #cell(name)="data">
          <span class="font-weight-semibold">{{ data.value }}</span>
        </template>
      </b-table>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.totalDocs"
            :per-page="pagination.limit"
            first-number
            last-number
            class="mb-1 mt-2 mr-1"
            prev-class="prev-item"
            next-class="next-item"
            @change="showCurrentPage($event)">
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18" />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import TicketPlantAdd from '@/components/Tickets/Plant/TicketPlantAdd.vue'
import TicketPlantDetail from '@/components/Tickets/Plant/TicketPlantDetail.vue'
import TicketPlantFilter from '@/components/Tickets/Plant/TicketPlantFilter.vue'
import DeleteModal from '@/components/DeleteModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TableTop from '@/components/TableTop.vue'
import PlantProvider from '@/resources/PlantProvider'

const PlantService = new PlantProvider()

export default {
  components: {
    TicketPlantAdd,
    TicketPlantDetail,
    TicketPlantFilter,
    DeleteModal,
    TableTop
  },
  data () {
    return {
      isSidebarActive: false,
      isSidebarDetailActive: false,
      isDeleteModalActive: false,
      filter: {
        searchCodeAndName: '',
        status: ''
      },
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 10
      },
      fields: [
        { key: 'code', label: 'Code', sortable: true },
        { key: 'name', label: 'Name' },
        { key: 'remark', label: 'Remark' },
        { key: 'status', label: 'Status' }
      ],
      items: [
        {
          code: 'P',
          name: 'โทรศัพท์',
          remark: 'Call Center',
          status: 'active'
        },
        {
          code: 'MB',
          name: 'โทรศัพท์มือถือ',
          remark: '',
          status: 'active'
        },
        {
          code: 'L',
          name: 'ไลน์',
          remark: '',
          status: 'active'
        },
        {
          code: 'M',
          name: 'อีเมลล์',
          remark: '',
          status: 'active'
        },
        {
          code: 'F',
          name: 'แฟกซ์',
          remark: '',
          status: 'active'
        },
        {
          code: 'O',
          name: 'อื่นๆ',
          remark: '',
          status: 'active'
        }
      ],
      selectedItem: {},
      initialTicketPlant: {},
      deleteItem: {}
    }
  },
  created () {
    this.getPlant()
  },
  methods: {
    async getPlant () {
      try {
        const data = await PlantService.paginate(this.pagination.page, this.pagination.limit, this.filter)
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (err) {
        console.error(err)
      }
    },
    async addTicketPlant (val) {
      try {
        await PlantService.createGroup(val)
        await this.getPlant()
        this.resetFormAndToggleSideBar(this.$refs.ticketPlantAdd)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Record Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Ticket Plant has been added'
          }
        })
      } catch (err) {
        console.error(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Ticket Plant has been Failed'
          }
        })
      }
    },
    async updateTicketPlant (val) {
      try {
        const payload = { ...val }
        delete payload.id
        const { data } = await PlantService.updateGroup(val.id, payload)
        await this.getPlant()
        this.setDataInitialAndSelectItem(data)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Updated Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Ticket Plant has been updated'
          }
        })
      } catch (err) {
        console.log(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Update Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Ticket Plant has been Failed'
          }
        })
      }
    },
    async confirmDelete (val) {
      try {
        this.isSidebarDetailActive = false
        await PlantService.deleteGroup(val.ID)
        await this.getPlant()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Ticket Plant has been deleted'
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: `😞 Ticket Plant has been Failed ${error}`
          }
        })
      }
    },
    activeSidebar () {
      this.isSidebarActive = true
    },
    rowClick (val) {
      this.setDataInitialAndSelectItem(val)
      this.isSidebarDetailActive = true
    },
    openDeleteModal (val) {
      this.deleteItem = { ...val }
      this.isDeleteModalActive = true
    },
    setDataInitialAndSelectItem (val) {
      this.selectedItem = { ...val }
      this.initialTicketPlant = { ...val }
    },
    resetFormAndToggleSideBar (ref) {
      this.isSidebarActive = !this.isSidebarActive
      if (ref && ref.resetForm()) ref.resetForm()
    },
    fetchFilter () {
      this.setPagination(1)
      this.getPlant()
    },
    showCurrentPage (page) {
      this.setPagination(page)
      this.getPlant()
    },
    setPagination (page, totalDocs) {
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs || this.pagination.totalDocs
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select {
  background: white;
}
.card-body {
  padding: 0;
}
::v-deep input.vs__search::placeholder {
  color: #B9B9C3;
}
</style>
